import axios from "axios";
import * as types from '../constants/ActionTypes';
import { toast } from 'react-toastify';

// Url's
const getProductCompareUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/product-compare`;

// Actions
const productCompareRequested = () => ({
    type: types.PRODUCT_COMPARE_REQUEST
  });

const productCompareSuccess = data => ({
    type: types.PRODUCT_COMPARE_SUCCESS,
    data
  });


    
const productCompareFailure = error => ({
    type: types.PRODUCT_COMPARE_FAILURE,
    error
  });

  // API
export const getComapreProductDetail = (options) => {
    return dispatch => {
      dispatch(productCompareRequested());
      axios.post(getProductCompareUrl, 
        options 
      , {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            //'Content-Type': 'application/json; charset=UTF-8'
          },
        })
        .then(res => {
          if (res.data.ack === "Success") {
            dispatch(productCompareSuccess(res.data.results));
          } else if (res.data.ack === "Failure") {
            toast.error(`Failed - ${res.data.status.message}`);
            dispatch(productCompareFailure(res.data.status));
          } 
        })
        .catch(err => {
            throw err;
          // dispatch(addTodoFailure(err.message));
        });
    };
  };

 